import { Metamodel, IViolation } from 'shell-models-lib';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { stringIsNullOrEmpty, format } from 'app/shared/utils/string.util';

import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { DataFlowExpression } from '../dataflowexpression';
import { SynapseAnalyticsSettings } from './synapse-analytics-settings';
import { IntegerDataFlowType } from '../dataflow-datatype';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.hive.dataflowSettings,
    validator: HiveSettings.validateSettings
})
export class HiveSettings extends SynapseAnalyticsSettings {
    @Metamodel.attribute({
    })
    public storageContainer: DataFlowExpression;

    @Metamodel.attribute({
    })
    public storageFolderPath: DataFlowExpression;

    @Metamodel.attribute({
    })
    public stagingDatabaseName: DataFlowExpression;

    @Metamodel.attribute({
    })
    public store: string;

    @Metamodel.attribute({
    })
    public clusteredBy: DataFlowExpression[];

    @Metamodel.attribute({
    })
    public clusteredByBuckets: DataFlowExpression;

    public static validateSettings(settings: HiveSettings): IViolation[] {
        const violations: IViolation[] = [];
        if (settings.transform.isInlineDataset && settings.transform.datasetSettings && settings.transform.datasetSettings.getFormat() === DatasetFormatType.Hive) {
            if (stringIsNullOrEmpty(settings.storageContainer.expression) && !(settings.transform instanceof DataFlowSink)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.DataFlowHiveLinkedServiceContainerName)
                });
            }
            if (settings.format !== 'query' && stringIsNullOrEmpty(settings.schemaName.expression)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.Dataset_TableOptions_Create_Schema_Placeholder)
                });
            }
            if (settings.format !== 'query' && stringIsNullOrEmpty(settings.tableName.expression)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.Table_name_Label)
                });
            }
            if (stringIsNullOrEmpty(settings.stagingDatabaseName.expression) && !(settings.transform instanceof DataFlowSink)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.Dataset_TableOptions_Staging_Database)
                });
            }
            if (settings.format === 'query' && settings.transform instanceof DataFlowSource && stringIsNullOrEmpty(settings.query.expression)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.QueryLabel)
                });
            }
        }

        return violations;
    }

    public get transform(): DataFlowSource | DataFlowSink {
        return this.owner instanceof DataFlowSource ? this.owner as DataFlowSource : this.owner as DataFlowSink;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Hive;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-100x100-Hive';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.format = 'table';
        this.staged = true;
        this.store = DatasetFormatType.Hive;
        this.stagingDatabaseName = this.transform.createTemplatableExpression();
        this.storageContainer = this.transform.createTemplatableExpression();
        this.storageFolderPath = this.transform.createTemplatableExpression();
        this.clusteredBy = [this.transform.createTemplatableExpression()];
        this.clusteredByBuckets = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
    }
}
